(function (angular) {
	'use strict';

	angular.module('investorOwnedModule', [
		'coreModule',
		'revealModule'
	]);
})(window.angular);